import { alertAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { ICONS_MAP, NOTIFICATION_VARIANTS, ROOT_MAP, TEXT_MAP } from '../common/AlertAndToast.common';
import { rem } from '../themeUtils';

const alertSlotRecipe = defineSlotRecipe({
  className: 'alert',
  slots: alertAnatomy.keys(),
  base: {
    // Everything is vertically centered. The icon hugs the top (`flex-start` below) so it lines
    // up with the first text line on multi-line alerts; the 32px action/close buttons ride the
    // text line via a negative block margin (see BitkitAlert.tsx) so they don't grow the row.
    // `rem(11)` block padding (not 12) lands the single-line alert on exactly 48px once the 1px
    // border is added.
    root: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid',
      borderRadius: '8',
      paddingBlock: rem(11),
      paddingInlineStart: '12',
      paddingInlineEnd: '8',
      width: '100%',
    },
    indicator: {
      alignSelf: 'flex-start',
      marginInlineEnd: '8',
      width: '24',
      height: '24',
    },
    content: {
      flex: '1',
    },
    title: {
      textStyle: 'comp/notification/title',
      '& + *': {
        marginBlockStart: '4',
      },
    },
    description: {
      textStyle: 'comp/notification/message',
      '&:first-of-type': {
        marginBlockStart: '2',
      },
    },
  },
  variants: {
    variant: Object.fromEntries(
      NOTIFICATION_VARIANTS.map((v) => [
        v,
        {
          indicator: { color: ICONS_MAP[v] },
          root: { ...ROOT_MAP[v], color: TEXT_MAP[v] },
        },
      ]),
    ),
  },
  defaultVariants: {
    variant: 'info',
  },
});

export default alertSlotRecipe;
